import { useMutation, useQueryClient } from "@tanstack/react-query";
import { favoriteBrandsMutationApi } from "@/shared/api/favorite-brands/mutation";
import { FavoriteBrandsRequestBody } from "@/shared/api/favorite-brands/types";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

// 즐겨찾기 브랜드 수정 — 성공 안내 UI는 호출부가 담당한다.
const useUpdateFavoriteBrands = () => {
  const { companyId } = useCompanyIdentity();
  const queryClient = useQueryClient();
  const { error } = useAppToasts({ id: "GLOBAL" });

  return useMutation({
    mutationFn: (body: FavoriteBrandsRequestBody) =>
      favoriteBrandsMutationApi.updateFavoriteBrands(companyId as number, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["favorite-brands", companyId],
      });
    },
    onError: (err) => {
      error(err);
    },
  });
};

export default useUpdateFavoriteBrands;
